import React, { useState, useEffect } from 'react';
import { ChevronUpIcon, CommandLineIcon } from '@heroicons/react/24/outline';

export default function AdminNavigator() {
  const [isVisible, setIsVisible] = useState(false);
  const [adminUrl, setAdminUrl] = useState('');

  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      setAdminUrl('http://localhost:3004');
    } else {
      setAdminUrl('/admin');
    }
  }, []);

  const navigateToAdmin = () => {
    if (adminUrl) {
      const currentToken = localStorage.getItem('authToken');
      const hashParams = currentToken ? `#token=${currentToken}&from=zoomfabric` : '#from=zoomfabric';
      window.open(`${adminUrl}${hashParams}`, '_blank');
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className={`mb-2 transform transition-all duration-200 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0 pointer-events-none'}`}>
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-3 min-w-[200px]">
          <p className="text-sm text-gray-600 mb-2">Admin Controls</p>
          <button
            onClick={navigateToAdmin}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
          >
            <CommandLineIcon className="h-4 w-4 mr-2" />
            Cognitive Fabric Control Center
          </button>
        </div>
      </div>

      <button
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
        className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        <ChevronUpIcon className="h-5 w-5" />
      </button>
    </div>
  );
}